<div [formGroup]="contactForm" (ngSubmit)="saveContact()" #formRef="ngForm">
  <div class="dialog-title">New Contact</div>

  <mat-form-field>
    <input matInput placeholder="Name" formControlName="name" required/>
    <mat-error>Name is required</mat-error>
  </mat-form-field>

  <mat-form-field *ngIf="countryCode" floatLabel="always">
    <ngx-mat-intl-tel-input [preferredCountries]="[countryCode]" [enablePlaceholder]="true" [enableSearch]="true"
      placeholder="Contact No." formControlName="phoneNo" required>
    </ngx-mat-intl-tel-input>
    <mat-error
      *ngIf="contactForm.controls.phoneNo?.errors?.required && !contactForm.controls.phoneNo?.errors?.validatePhoneNumber">
      Contact No. is required
    </mat-error>
    <mat-error *ngIf="contactForm.controls.phoneNo?.errors?.validatePhoneNumber">
      Invalid Contact No.
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <input matInput placeholder="Email" formControlName="email" required />
    <mat-error *ngIf="contactForm.controls.email?.errors?.required">Email is required</mat-error>
    <mat-error *ngIf="contactForm.controls.email?.errors?.used">Email is used!</mat-error>
    <mat-error *ngIf="contactForm.controls.email?.errors?.email">Invalid Email Format</mat-error>
  </mat-form-field>

  <div class="dialog-buttons">
    <button mat-button color="primary" [mat-dialog-close]="false">Cancel</button>
    <button mat-button color="primary" (click)="saveContact()">Save</button>
  </div>
</div>